<template>
  <section class="home" id="home">
    <div class="home-overlay"></div>
    <div class="container home-content">
      <h1 class="wow slideInLeft" data-wow-delay="0.5s">
        No<span> pain</span> no gain
      </h1>
      <h1 class="wow slideInRight" data-wow-delay="0.8s">
        We are <span>Diamond Gym</span>
      </h1>
    </div>
    <a href="#about" class="go-down wow fadeInUp" data-wow-delay="1.2s">
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </a>
  </section>
</template>

<script>
export default {
  name: "HomeSection",
}
</script>

<style scoped>
.home {
  position: relative;
  background: url("@/assets/images/homepage.webp") center / cover no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding-top: 80px;
}

.home-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0.4) 50%,
    rgba(0, 0, 0, 0.7) 100%
  );
}

.home-content {
  position: relative;
  z-index: 1;
  text-align: center;
}

.home h1 {
  font-size: clamp(28px, 6vw, 64px);
  text-align: center;
  margin: 8px 0;
  text-shadow: 0 2px 16px rgba(0, 0, 0, 0.6);
  letter-spacing: 0.02em;
}

.home h1 span {
  color: #E8B923;
}

.go-down {
  position: relative;
  z-index: 1;
  margin-top: 48px;
  width: 50px;
  height: 50px;
  border: 2px solid rgba(232, 185, 35, 0.8);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #E8B923;
  font-size: 20px;
  transition: background-color 0.3s ease, color 0.3s ease, transform 0.3s ease, border-color 0.3s ease;
  animation: bounce 2s infinite 2s;
}

.go-down:hover {
  background-color: #E8B923;
  color: #000;
  border-color: #E8B923;
  transform: translateY(4px);
  animation: none;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(6px); }
}

@media (max-width: 768px) {
  .home h1 {
    font-size: clamp(22px, 7vw, 36px);
    line-height: 1.3;
  }
}
</style>
